export default __webpack_public_path__ + "static/media/Nuffield-gym-offer_580x400.498dfcec.jpg";